// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 547) return "static/chunks/547-4d94ccebc195765e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"165":"babee66d844cb773","640":"d138aa1758564008"}[chunkId] + ".js";
};